import React, { FunctionComponent, ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Caption, { CaptionProps } from './Caption'

export type CaptionWithButtonProps = CaptionProps & { button: ReactElement }

const CaptionWithButton: FunctionComponent<CaptionWithButtonProps> = ({ caption, button }) => (
    <Grid noExpand marginTop={64} paddingX={5}>
        <Grid noExpand marginTop={6}>
            <Caption caption={caption} />
        </Grid>
        <Grid noExpand marginTop={6}>
            {button}
        </Grid>
    </Grid>
)
export default CaptionWithButton
